<template>
    <div class="api-management">
      <!-- <h2>第三方接口管理</h2> -->
      
      <!-- 系统概览卡片 -->
      <el-row :gutter="20" class="dashboard-cards">
        <el-col :span="6">
          <el-card shadow="hover" class="dashboard-card">
            <div class="card-content">
              <div class="card-icon his">
                <i class="el-icon-s-platform"></i>
              </div>
              <div class="card-data">
                <div class="card-title">HIS系统接口</div>
                <div class="card-value">25</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <el-col :span="6">
          <el-card shadow="hover" class="dashboard-card">
            <div class="card-content">
              <div class="card-icon pacs">
                <i class="el-icon-picture"></i>
              </div>
              <div class="card-data">
                <div class="card-title">PACS影像接口</div>
                <div class="card-value">8</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <el-col :span="6">
          <el-card shadow="hover" class="dashboard-card">
            <div class="card-content">
              <div class="card-icon lis">
                <i class="el-icon-s-data"></i>
              </div>
              <div class="card-data">
                <div class="card-title">LIS检验接口</div>
                <div class="card-value">12</div>
              </div>
            </div>
          </el-card>
        </el-col>
        
        <el-col :span="6">
          <el-card shadow="hover" class="dashboard-card">
            <div class="card-content">
              <div class="card-icon other">
                <i class="el-icon-connection"></i>
              </div>
              <div class="card-data">
                <div class="card-title">其他接口</div>
                <div class="card-value">15</div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      
      <!-- 搜索过滤区域 -->
      <el-card class="filter-container">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="接口名称">
            <el-input v-model="searchForm.name" placeholder="请输入接口名称"></el-input>
          </el-form-item>
          
          <el-form-item label="接口系统">
            <el-select v-model="searchForm.system" placeholder="请选择系统" clearable>
              <el-option label="HIS系统" value="HIS"></el-option>
              <el-option label="PACS系统" value="PACS"></el-option>
              <el-option label="LIS系统" value="LIS"></el-option>
              <el-option label="EMR系统" value="EMR"></el-option>
              <el-option label="其他系统" value="OTHER"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="接口类型">
            <el-select v-model="searchForm.type" placeholder="请选择类型" clearable>
              <el-option label="患者信息" value="PATIENT"></el-option>
              <el-option label="病历管理" value="RECORDS"></el-option>
              <el-option label="医嘱管理" value="PRESCRIPTION"></el-option>
              <el-option label="检查检验" value="EXAMINATION"></el-option>
              <el-option label="药品管理" value="MEDICINE"></el-option>
              <el-option label="费用结算" value="PAYMENT"></el-option>
              <el-option label="其他" value="OTHER"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="状态">
            <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
              <el-option label="已启用" value="ENABLED"></el-option>
              <el-option label="未启用" value="DISABLED"></el-option>
              <el-option label="开发中" value="DEVELOPING"></el-option>
              <el-option label="已废弃" value="DEPRECATED"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      
      <!-- 操作按钮区域 -->
      <div class="operation-area">
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加接口</el-button>
        <el-button type="success" icon="el-icon-upload2" @click="handleImport">批量导入</el-button>
        <el-button type="warning" icon="el-icon-download" @click="handleExport">导出接口文档</el-button>
      </div>
      
      <!-- 接口列表 -->
      <el-table
        :data="filteredApis"
        border
        style="width: 100%; margin-top: 15px"
        v-loading="loading"
      >
        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
        <el-table-column prop="name" label="接口名称" min-width="180">
          <template slot-scope="scope">
            <div class="api-name">
              <el-tag size="medium" :type="getSystemTagType(scope.row.system)">{{ scope.row.system }}</el-tag>
              <span style="margin-left: 8px">{{ scope.row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="url" label="接口地址" min-width="220" show-overflow-tooltip></el-table-column>
        <el-table-column prop="method" label="请求方式" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.method === 'GET' ? 'success' : 'primary'">{{ scope.row.method }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="接口类型" width="120" align="center"></el-table-column>
        <el-table-column prop="version" label="版本" width="100" align="center"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="170" align="center"></el-table-column>
        <el-table-column prop="status" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="260" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" icon="el-icon-view" @click="handleView(scope.row)">查看</el-button>
            <el-button size="mini" type="success" icon="el-icon-edit" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页组件 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
      
      <!-- 添加/编辑接口对话框 -->
      <el-dialog 
        :title="dialogType === 'add' ? '添加接口' : '编辑接口'" 
        :visible.sync="dialogVisible" 
        width="800px"
        :close-on-click-modal="false"
        @closed="resetForm('apiForm')"
      >
        <el-form :model="apiForm" :rules="apiRules" ref="apiForm" label-width="120px">
          <el-tabs v-model="activeTab">
            <el-tab-pane label="基本信息" name="basic">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="接口名称" prop="name">
                    <el-input v-model="apiForm.name" placeholder="请输入接口名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="所属系统" prop="system">
                    <el-select v-model="apiForm.system" placeholder="请选择所属系统" style="width: 100%">
                      <el-option label="HIS系统" value="HIS"></el-option>
                      <el-option label="PACS系统" value="PACS"></el-option>
                      <el-option label="LIS系统" value="LIS"></el-option>
                      <el-option label="EMR系统" value="EMR"></el-option>
                      <el-option label="其他系统" value="OTHER"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="接口类型" prop="type">
                    <el-select v-model="apiForm.type" placeholder="请选择接口类型" style="width: 100%">
                      <el-option label="患者信息" value="患者信息"></el-option>
                      <el-option label="病历管理" value="病历管理"></el-option>
                      <el-option label="医嘱管理" value="医嘱管理"></el-option>
                      <el-option label="检查检验" value="检查检验"></el-option>
                      <el-option label="药品管理" value="药品管理"></el-option>
                      <el-option label="费用结算" value="费用结算"></el-option>
                      <el-option label="其他" value="其他"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="接口版本" prop="version">
                    <el-input v-model="apiForm.version" placeholder="请输入接口版本"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              
              <el-form-item label="接口地址" prop="url">
                <el-input v-model="apiForm.url" placeholder="请输入接口地址"></el-input>
              </el-form-item>
              
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item label="请求方式" prop="method">
                    <el-select v-model="apiForm.method" placeholder="请选择请求方式" style="width: 100%">
                      <el-option label="GET" value="GET"></el-option>
                      <el-option label="POST" value="POST"></el-option>
                      <el-option label="PUT" value="PUT"></el-option>
                      <el-option label="DELETE" value="DELETE"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="状态" prop="status">
                    <el-select v-model="apiForm.status" placeholder="请选择状态" style="width: 100%">
                      <el-option label="已启用" value="已启用"></el-option>
                      <el-option label="未启用" value="未启用"></el-option>
                      <el-option label="开发中" value="开发中"></el-option>
                      <el-option label="已废弃" value="已废弃"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              
              <el-form-item label="接口说明" prop="description">
                <el-input type="textarea" v-model="apiForm.description" :rows="4" placeholder="请输入接口详细说明"></el-input>
              </el-form-item>
            </el-tab-pane>
            
            <el-tab-pane label="请求参数" name="request">
              <div class="param-header">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="addRequestParam">添加参数</el-button>
              </div>
              
              <el-table :data="apiForm.requestParams" border style="width: 100%">
                <el-table-column prop="name" label="参数名" min-width="120">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.name" size="small" placeholder="参数名"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="参数类型" width="120">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.type" size="small" placeholder="类型" style="width: 100%">
                      <el-option label="字符串" value="字符串"></el-option>
                      <el-option label="数字" value="数字"></el-option>
                      <el-option label="布尔" value="布尔"></el-option>
                      <el-option label="时间" value="时间"></el-option>
                      <el-option label="数组" value="数组"></el-option>
                      <el-option label="对象" value="对象"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="required" label="是否必填" width="100">
                  <template slot-scope="scope">
                    <el-switch v-model="scope.row.required"></el-switch>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="参数说明">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.description" size="small" placeholder="参数说明"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" icon="el-icon-delete" @click="removeRequestParam(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            
            <el-tab-pane label="响应参数" name="response">
              <div class="param-header">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="addResponseParam">添加参数</el-button>
              </div>
              
              <el-table :data="apiForm.responseParams" border style="width: 100%">
                <el-table-column prop="name" label="参数名" min-width="120">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.name" size="small" placeholder="参数名"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="参数类型" width="120">
                  <template slot-scope="scope">
                    <el-select v-model="scope.row.type" size="small" placeholder="类型" style="width: 100%">
                      <el-option label="字符串" value="字符串"></el-option>
                      <el-option label="数字" value="数字"></el-option>
                      <el-option label="布尔" value="布尔"></el-option>
                      <el-option label="时间" value="时间"></el-option>
                      <el-option label="数组" value="数组"></el-option>
                      <el-option label="对象" value="对象"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="参数说明">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.description" size="small" placeholder="参数说明"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" icon="el-icon-delete" @click="removeResponseParam(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            
            <el-tab-pane label="错误码" name="errors">
              <div class="param-header">
                <el-button size="small" type="primary" icon="el-icon-plus" @click="addErrorCode">添加错误码</el-button>
              </div>
              
              <el-table :data="apiForm.errorCodes" border style="width: 100%">
                <el-table-column prop="code" label="错误码" width="120">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.code" size="small" placeholder="错误码"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="message" label="错误信息">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.message" size="small" placeholder="错误信息"></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="description" label="说明">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.description" size="small" placeholder="说明"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="80" align="center">
                  <template slot-scope="scope">
                    <el-button size="mini" type="danger" icon="el-icon-delete" @click="removeErrorCode(scope.$index)"></el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </div>
      </el-dialog>
      
      <!-- 查看接口详情对话框 -->
      <el-dialog 
        title="接口详情" 
        :visible.sync="viewDialogVisible" 
        width="800px"
      >
        <el-descriptions title="基本信息" :column="2" border>
          <el-descriptions-item label="接口名称">{{ currentApi.name }}</el-descriptions-item>
          <el-descriptions-item label="所属系统">{{ currentApi.system }}</el-descriptions-item>
          <el-descriptions-item label="接口类型">{{ currentApi.type }}</el-descriptions-item>
          <el-descriptions-item label="接口版本">{{ currentApi.version }}</el-descriptions-item>
          <el-descriptions-item label="请求方式">{{ currentApi.method }}</el-descriptions-item>
          <el-descriptions-item label="状态">
            <el-tag :type="getStatusTagType(currentApi.status)">{{ currentApi.status }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="接口地址" :span="2">{{ currentApi.url }}</el-descriptions-item>
          <el-descriptions-item label="接口说明" :span="2">{{ currentApi.description }}</el-descriptions-item>
        </el-descriptions>
        
        <el-divider></el-divider>
        
        <h4>请求参数</h4>
        <el-table 
          :data="currentApi.requestParams || []" 
          border 
          style="width: 100%; margin-bottom: 20px">
          <el-table-column prop="name" label="参数名" min-width="120"></el-table-column>
          <el-table-column prop="type" label="参数类型" width="120"></el-table-column>
          <el-table-column prop="required" label="是否必填" width="100">
            <template slot-scope="scope">
              <el-tag size="mini" :type="scope.row.required ? 'danger' : 'info'">
                {{ scope.row.required ? '必填' : '选填' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="description" label="参数说明"></el-table-column>
        </el-table>
        
        <h4>响应参数</h4>
        <el-table 
          :data="currentApi.responseParams || []" 
          border 
          style="width: 100%; margin-bottom: 20px">
          <el-table-column prop="name" label="参数名" min-width="120"></el-table-column>
          <el-table-column prop="type" label="参数类型" width="120"></el-table-column>
          <el-table-column prop="description" label="参数说明"></el-table-column>
        </el-table>
        
        <h4>错误码</h4>
        <el-table 
          :data="currentApi.errorCodes || []" 
          border 
          style="width: 100%">
          <el-table-column prop="code" label="错误码" width="120"></el-table-column>
          <el-table-column prop="message" label="错误信息"></el-table-column>
          <el-table-column prop="description" label="说明"></el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: 'api-management',
    data() {
      return {
        // 搜索表单
        searchForm: {
          name: '',
          system: '',
          type: '',
          status: ''
        },
        
        // 表格加载状态
        loading: false,
        
        // 分页相关
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
        
        // 对话框相关
        dialogVisible: false,
        viewDialogVisible: false,
        dialogType: 'add',
        activeTab: 'basic',
        
        // 当前查看的接口
        currentApi: {},
        
        // 接口表单
        apiForm: {
          name: '',
          system: '',
          type: '',
          version: '1.0.0',
          url: '',
          method: 'GET',
          status: '开发中',
          description: '',
          requestParams: [],
          responseParams: [],
          errorCodes: []
        },
        
        // 表单验证规则
        apiRules: {
          name: [
            { required: true, message: '请输入接口名称', trigger: 'blur' }
          ],
          system: [
            { required: true, message: '请选择所属系统', trigger: 'change' }
          ],
          type: [
            { required: true, message: '请选择接口类型', trigger: 'change' }
          ],
          url: [
            { required: true, message: '请输入接口地址', trigger: 'blur' }
          ],
          method: [
            { required: true, message: '请选择请求方式', trigger: 'change' }
          ]
        },
        
        // 接口列表数据（模拟数据）
        apiList: [
          {
            id: 1,
            name: '获取患者基本信息',
            system: 'HIS',
            type: '患者信息',
            version: '1.0.0',
            url: 'https://api.hospital.com/his/patient/info',
            method: 'GET',
            status: '已启用',
            updateTime: '2023-04-15 14:30:25',
            description: '根据患者ID获取患者基本信息，包括姓名、年龄、性别、联系方式等',
            requestParams: [
              { name: 'patientId', type: '字符串', required: true, description: '患者ID' },
              { name: 'includeAddress', type: '布尔', required: false, description: '是否包含地址信息' }
            ],
            responseParams: [
              { name: 'id', type: '字符串', description: '患者ID' },
              { name: 'name', type: '字符串', description: '患者姓名' },
              { name: 'gender', type: '字符串', description: '性别' },
              { name: 'age', type: '数字', description: '年龄' },
              { name: 'phone', type: '字符串', description: '联系电话' },
              { name: 'idCard', type: '字符串', description: '身份证号' },
              { name: 'address', type: '对象', description: '地址信息对象' }
            ],
            errorCodes: [
              { code: '404', message: 'Patient not found', description: '患者不存在' },
              { code: '400', message: 'Invalid patient ID', description: '无效的患者ID格式' }
            ]
          },
          {
            id: 2,
            name: '获取患者就诊记录',
            system: 'HIS',
            type: '病历管理',
            version: '1.1.0',
            url: 'https://api.hospital.com/his/patient/visits',
            method: 'GET',
            status: '已启用',
            updateTime: '2023-04-16 09:15:30',
            description: '获取患者的所有就诊记录，包括就诊科室、医生、时间、诊断结果等',
            requestParams: [
              { name: 'patientId', type: '字符串', required: true, description: '患者ID' },
              { name: 'startDate', type: '时间', required: false, description: '开始日期' },
              { name: 'endDate', type: '时间', required: false, description: '结束日期' },
              { name: 'pageSize', type: '数字', required: false, description: '每页记录数' },
              { name: 'pageNum', type: '数字', required: false, description: '页码' }
            ],
            responseParams: [
              { name: 'total', type: '数字', description: '总记录数' },
              { name: 'pageSize', type: '数字', description: '每页记录数' },
              { name: 'pageNum', type: '数字', description: '当前页码' },
              { name: 'list', type: '数组', description: '就诊记录列表' }
            ],
            errorCodes: [
              { code: '404', message: 'Patient not found', description: '患者不存在' },
              { code: '400', message: 'Invalid date format', description: '日期格式错误' }
            ]
          },
          {
            id: 3,
            name: '上传患者检验报告',
            system: 'LIS',
            type: '检查检验',
            version: '2.0.0',
            url: 'https://api.hospital.com/lis/report/upload',
            method: 'POST',
            status: '开发中',
            updateTime: '2023-04-18 16:20:45',
            description: '上传患者的检验报告数据，支持多种类型的检验报告',
            requestParams: [
              { name: 'patientId', type: '字符串', required: true, description: '患者ID' },
              { name: 'visitId', type: '字符串', required: true, description: '就诊ID' },
              { name: 'reportType', type: '字符串', required: true, description: '报告类型' },
              { name: 'reportData', type: '对象', required: true, description: '报告数据' },
              { name: 'doctorId', type: '字符串', required: true, description: '医生ID' },
              { name: 'reportTime', type: '时间', required: true, description: '报告时间' }
            ],
            responseParams: [
              { name: 'success', type: '布尔', description: '是否成功' },
              { name: 'reportId', type: '字符串', description: '报告ID' }
            ],
            errorCodes: [
              { code: '404', message: 'Patient not found', description: '患者不存在' },
              { code: '400', message: 'Invalid report data', description: '报告数据格式错误' },
              { code: '403', message: 'No permission', description: '没有权限上传报告' }
            ]
          },
          {
            id: 4,
            name: '获取医生排班信息',
            system: 'HIS',
            type: '医嘱管理',
            version: '1.0.5',
            url: 'https://api.hospital.com/his/doctor/schedule',
            method: 'GET',
            status: '已启用',
            updateTime: '2023-04-10 11:05:15',
            description: '获取医生的排班信息，支持按科室、医生、日期等条件查询',
            requestParams: [
              { name: 'departmentId', type: '字符串', required: false, description: '科室ID' },
              { name: 'doctorId', type: '字符串', required: false, description: '医生ID' },
              { name: 'startDate', type: '时间', required: true, description: '开始日期' },
              { name: 'endDate', type: '时间', required: true, description: '结束日期' }
            ],
            responseParams: [
              { name: 'schedules', type: '数组', description: '排班列表' }
            ],
            errorCodes: [
              { code: '400', message: 'Invalid date range', description: '日期范围无效' },
              { code: '404', message: 'Doctor not found', description: '医生不存在' }
            ]
          },
          {
            id: 5,
            name: '查询药品库存',
            system: 'HIS',
            type: '药品管理',
            version: '1.2.0',
            url: 'https://api.hospital.com/his/medicine/stock',
            method: 'GET',
            status: '已启用',
            updateTime: '2023-04-05 14:30:00',
            description: '查询药品的库存情况，支持按药品名称、编码等条件查询',
            requestParams: [
              { name: 'medicineName', type: '字符串', required: false, description: '药品名称' },
              { name: 'medicineCode', type: '字符串', required: false, description: '药品编码' },
              { name: 'categoryId', type: '字符串', required: false, description: '药品类别ID' },
              { name: 'pageSize', type: '数字', required: false, description: '每页记录数' },
              { name: 'pageNum', type: '数字', required: false, description: '页码' }
            ],
            responseParams: [
              { name: 'total', type: '数字', description: '总记录数' },
              { name: 'pageSize', type: '数字', description: '每页记录数' },
              { name: 'pageNum', type: '数字', description: '当前页码' },
              { name: 'list', type: '数组', description: '药品库存列表' }
            ],
            errorCodes: [
              { code: '400', message: 'Invalid parameter', description: '参数错误' }
            ]
          },
          {
            id: 6,
            name: '获取患者影像资料',
            system: 'PACS',
            type: '检查检验',
            version: '2.1.0',
            url: 'https://api.hospital.com/pacs/patient/images',
            method: 'GET',
            status: '已启用',
            updateTime: '2023-04-12 10:20:35',
            description: '获取患者的影像学检查资料，如X光、CT、核磁共振等',
            requestParams: [
              { name: 'patientId', type: '字符串', required: true, description: '患者ID' },
              { name: 'visitId', type: '字符串', required: false, description: '就诊ID' },
              { name: 'examType', type: '字符串', required: false, description: '检查类型' },
              { name: 'startDate', type: '时间', required: false, description: '开始日期' },
              { name: 'endDate', type: '时间', required: false, description: '结束日期' }
            ],
            responseParams: [
              { name: 'total', type: '数字', description: '总记录数' },
              { name: 'images', type: '数组', description: '影像资料列表' }
            ],
            errorCodes: [
              { code: '404', message: 'Patient not found', description: '患者不存在' },
              { code: '403', message: 'No permission', description: '没有权限查看影像资料' }
            ]
          },
          {
            id: 7,
            name: '患者费用结算',
            system: 'HIS',
            type: '费用结算',
            version: '1.0.0',
            url: 'https://api.hospital.com/his/payment/settle',
            method: 'POST',
            status: '已启用',
            updateTime: '2023-04-08 09:40:15',
            description: '对患者的医疗费用进行结算',
            requestParams: [
              { name: 'patientId', type: '字符串', required: true, description: '患者ID' },
              { name: 'visitId', type: '字符串', required: true, description: '就诊ID' },
              { name: 'items', type: '数组', required: true, description: '费用项目列表' },
              { name: 'paymentMethod', type: '字符串', required: true, description: '支付方式' },
              { name: 'insuranceType', type: '字符串', required: false, description: '医保类型' }
            ],
            responseParams: [
              { name: 'success', type: '布尔', description: '是否成功' },
              { name: 'billId', type: '字符串', description: '账单ID' },
              { name: 'totalAmount', type: '数字', description: '总金额' },
              { name: 'paidAmount', type: '数字', description: '实际支付金额' },
              { name: 'insuranceAmount', type: '数字', description: '医保报销金额' }
            ],
            errorCodes: [
              { code: '404', message: 'Patient not found', description: '患者不存在' },
              { code: '400', message: 'Invalid payment data', description: '支付数据错误' },
              { code: '500', message: 'Payment system error', description: '支付系统错误' }
            ]
          },
          {
            id: 8,
            name: '创建电子病历',
            system: 'EMR',
            type: '病历管理',
            version: '1.5.0',
            url: 'https://api.hospital.com/emr/record/create',
            method: 'POST',
            status: '开发中',
            updateTime: '2023-04-20 15:10:25',
            description: '创建患者的电子病历记录',
            requestParams: [
              { name: 'patientId', type: '字符串', required: true, description: '患者ID' },
              { name: 'visitId', type: '字符串', required: true, description: '就诊ID' },
              { name: 'doctorId', type: '字符串', required: true, description: '医生ID' },
              { name: 'departmentId', type: '字符串', required: true, description: '科室ID' },
              { name: 'chiefComplaint', type: '字符串', required: true, description: '主诉' },
              { name: 'presentIllness', type: '字符串', required: true, description: '现病史' },
              { name: 'pastHistory', type: '字符串', required: false, description: '既往史' },
              { name: 'diagnosis', type: '数组', required: true, description: '诊断结果' },
              { name: 'treatment', type: '字符串', required: true, description: '治疗方案' }
            ],
            responseParams: [
              { name: 'success', type: '布尔', description: '是否成功' },
              { name: 'recordId', type: '字符串', description: '病历ID' }
            ],
            errorCodes: [
              { code: '404', message: 'Patient not found', description: '患者不存在' },
              { code: '400', message: 'Required fields missing', description: '缺少必填字段' },
              { code: '403', message: 'No permission', description: '没有权限创建病历' }
            ]
          }
        ]
      }
    },
    computed: {
      // 过滤后的接口列表
      filteredApis() {
        let results = this.apiList;
        
        // 接口名称过滤
        if (this.searchForm.name) {
          const keyword = this.searchForm.name.toLowerCase();
          results = results.filter(api => 
            api.name.toLowerCase().includes(keyword) || 
            api.url.toLowerCase().includes(keyword)
          );
        }
        
        // 接口系统过滤
        if (this.searchForm.system) {
          results = results.filter(api => api.system === this.searchForm.system);
        }
        
        // 接口类型过滤
        if (this.searchForm.type) {
          results = results.filter(api => {
            // 在实际应用中，这里应该根据类型代码查找对应的类型，这里简化处理
            if (this.searchForm.type === 'PATIENT' && api.type === '患者信息') return true;
            if (this.searchForm.type === 'RECORDS' && api.type === '病历管理') return true;
            if (this.searchForm.type === 'PRESCRIPTION' && api.type === '医嘱管理') return true;
            if (this.searchForm.type === 'EXAMINATION' && api.type === '检查检验') return true;
            if (this.searchForm.type === 'MEDICINE' && api.type === '药品管理') return true;
            if (this.searchForm.type === 'PAYMENT' && api.type === '费用结算') return true;
            if (this.searchForm.type === 'OTHER' && api.type === '其他') return true;
            return false;
          });
        }
        
        // 状态过滤
        if (this.searchForm.status) {
          results = results.filter(api => {
            if (this.searchForm.status === 'ENABLED' && api.status === '已启用') return true;
            if (this.searchForm.status === 'DISABLED' && api.status === '未启用') return true;
            if (this.searchForm.status === 'DEVELOPING' && api.status === '开发中') return true;
            if (this.searchForm.status === 'DEPRECATED' && api.status === '已废弃') return true;
            return false;
          });
        }
        
        // 更新总数
        this.totalCount = results.length;
        
        // 分页处理
        const startIndex = (this.currentPage - 1) * this.pageSize;
        const endIndex = startIndex + this.pageSize;
        return results.slice(startIndex, endIndex);
      }
    },
    created() {
      this.totalCount = this.apiList.length;
    },
    methods: {
      // 搜索处理
      handleSearch() {
        this.currentPage = 1;
        // 实际应用中这里可能需要调用API
      },
      
      // 重置搜索条件
      resetSearch() {
        this.$refs.searchForm.resetFields();
        this.currentPage = 1;
      },
      
      // 分页相关方法
      handleSizeChange(val) {
        this.pageSize = val;
      },
      handleCurrentChange(val) {
        this.currentPage = val;
      },
      
      // 添加接口
      handleAdd() {
        this.dialogType = 'add';
        this.apiForm = {
          name: '',
          system: '',
          type: '',
          version: '1.0.0',
          url: '',
          method: 'GET',
          status: '开发中',
          description: '',
          requestParams: [],
          responseParams: [],
          errorCodes: []
        };
        this.activeTab = 'basic';
        this.dialogVisible = true;
        
        // 确保表单验证重置
        this.$nextTick(() => {
          if (this.$refs.apiForm) {
            this.$refs.apiForm.resetFields();
          }
        });
      },
      
      // 编辑接口
      handleEdit(row) {
        this.dialogType = 'edit';
        this.activeTab = 'basic';
        
        // 深拷贝数据，避免直接修改表格数据
        this.apiForm = JSON.parse(JSON.stringify(row));
        this.dialogVisible = true;
      },
      
      // 查看接口详情
      handleView(row) {
        this.currentApi = row;
        this.viewDialogVisible = true;
      },
      
      // 删除接口
      handleDelete(row) {
        this.$confirm('确定要删除该接口吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 模拟删除成功
          const index = this.apiList.findIndex(api => api.id === row.id);
          if (index !== -1) {
            this.apiList.splice(index, 1);
            this.totalCount--;
            this.$message.success('删除成功');
          }
        }).catch(() => {
          // 取消删除
        });
      },
      
      // 导入接口
      handleImport() {
        this.$message({
          message: '接口批量导入功能开发中',
          type: 'info'
        });
      },
      
      // 导出接口文档
      handleExport() {
        this.$message({
          message: '接口文档导出成功',
          type: 'success'
        });
      },
      
      // 获取系统标签类型
      getSystemTagType(system) {
        switch (system) {
          case 'HIS': return 'primary';
          case 'PACS': return 'success';
          case 'LIS': return 'warning';
          case 'EMR': return 'info';
          default: return '';
        }
      },
      
      // 获取状态标签类型
      getStatusTagType(status) {
        switch (status) {
          case '已启用': return 'success';
          case '未启用': return 'info';
          case '开发中': return 'warning';
          case '已废弃': return 'danger';
          default: return '';
        }
      },
      
      // 添加请求参数
      addRequestParam() {
        this.apiForm.requestParams.push({
          name: '',
          type: '字符串',
          required: false,
          description: ''
        });
      },
      
      // 移除请求参数
      removeRequestParam(index) {
        this.apiForm.requestParams.splice(index, 1);
      },
      
      // 添加响应参数
      addResponseParam() {
        this.apiForm.responseParams.push({
          name: '',
          type: '字符串',
          description: ''
        });
      },
      
      // 移除响应参数
      removeResponseParam(index) {
        this.apiForm.responseParams.splice(index, 1);
      },
      
      // 添加错误码
      addErrorCode() {
        this.apiForm.errorCodes.push({
          code: '',
          message: '',
          description: ''
        });
      },
      
      // 移除错误码
      removeErrorCode(index) {
        this.apiForm.errorCodes.splice(index, 1);
      },
      
      // 重置表单
      resetForm(formName) {
        if (this.$refs[formName]) {
          this.$refs[formName].resetFields();
        }
      },
      
      // 提交表单
      submitForm() {
        this.$refs.apiForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            setTimeout(() => {
              if (this.dialogType === 'add') {
                // 模拟添加成功
                const newApi = {
                  ...this.apiForm,
                  id: this.apiList.length + 1,
                  updateTime: new Date().toLocaleString()
                };
                this.apiList.push(newApi);
                this.totalCount++;
                this.$message.success('添加接口成功');
              } else {
                // 模拟编辑成功
                const index = this.apiList.findIndex(api => api.id === this.apiForm.id);
                if (index !== -1) {
                  this.apiForm.updateTime = new Date().toLocaleString();
                  this.apiList[index] = { ...this.apiForm };
                  this.$message.success('更新接口成功');
                }
              }
              this.loading = false;
              this.dialogVisible = false;
            }, 500);
          } else {
            this.activeTab = 'basic'; // 切换到基本信息标签，显示验证错误
            return false;
          }
        });
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .api-management {
    padding: 20px;
    
    h2 {
      margin-bottom: 20px;
      font-weight: 500;
      color: #303133;
    }
    
    .dashboard-cards {
      margin-bottom: 20px;
      
      .dashboard-card {
        .card-content {
          display: flex;
          align-items: center;
          
          .card-icon {
            width: 50px;
            height: 50px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-right: 15px;
            
            i {
              font-size: 24px;
              color: #fff;
            }
            
            &.his {
              background-color: #409EFF;
            }
            
            &.pacs {
              background-color: #67C23A;
            }
            
            &.lis {
              background-color: #E6A23C;
            }
            
            &.other {
              background-color: #909399;
            }
          }
          
          .card-data {
            .card-title {
              font-size: 14px;
              color: #909399;
            }
            
            .card-value {
              font-size: 24px;
              font-weight: bold;
              color: #303133;
            }
          }
        }
      }
    }
    
    .filter-container {
      margin-bottom: 20px;
      
      .el-form {
        display: flex;
        flex-wrap: wrap;
      }
    }
    
    .operation-area {
      margin-bottom: 15px;
    }
    
    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    
    .api-name {
      display: flex;
      align-items: center;
    }
    
    .param-header {
      margin-bottom: 15px;
      display: flex;
      justify-content: flex-start;
    }
    
    h4 {
      margin: 15px 0;
      font-weight: 500;
      color: #303133;
    }
  }
  </style>